import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  IconButton,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { toMoney } from "../../util/Utils";
import { Box, TextField } from "@mui/material";
import { UseWalletManage } from "./UseWalletManage";
import ClearIcon from "@mui/icons-material/Clear";
import useBreakpoints from "../../hooks/useBreakpoints";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function RequastDetails(props) {
  const { geRequestById, ConfirmWallet } = UseWalletManage();
  const [detailRes, setDetailRes] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showNotConfirm, setShowNotConfirm] = useState(false);
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    if (props.openDetail.id) {
      geRequestById(props.openDetail.id, (callback) => {
        setDetailRes(callback);
      });
    }
  }, [props.openDetail]);

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      open={props.openDetail.show}
      onClose={() => props.setOpenDetail({ ...props.openDetail, show: false })}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography color="secondary" variant="subtitle2">
            جزئیات درخواست
          </Typography>

          <IconButton
            onClick={() => {
              props.setOpenDetail({ ...props.openDetail, show: false });
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={showConfirm}
          onClose={() => setShowConfirm(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از تایید درخواست اطمینان دارید؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => {
                setProgress(true);
                let model = { ID: detailRes.id, Confirm: true };
                ConfirmWallet(model, () => {
                  props.setOpenDetail({ ...props.openDetail, show: false });
                  props.CallBack();
                });
              }}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setShowConfirm(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={showNotConfirm}
          onClose={() => setShowNotConfirm(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از عدم تایید درخواست اطمینان دارید؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => {
                let model = { ID: detailRes.id, Confirm: false };
                ConfirmWallet(model, () => {
                  props.setOpenDetail({ ...props.openDetail, show: false });
                  props.CallBack();
                });
              }}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setShowNotConfirm(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        {detailRes && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="نام کاربر"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.fullName ? detailRes.fullName : ""
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="موبایل"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={detailRes && detailRes.mobile ? detailRes.mobile : ""}
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="عنوان"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={detailRes && detailRes.title ? detailRes.title : ""}
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="تاریخ درخواست"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.shamsiLogdate
                    ? detailRes.shamsiLogdate
                    : ""
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="اپراتور"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.operatorName
                    ? detailRes.operatorName
                    : ""
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}></Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="مبلغ فعلی کیف پول"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.currentWalletCost
                    ? toMoney(detailRes.currentWalletCost)
                    : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              {!detailRes.type ? (
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="مبلغ درخواستی"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    bgcolor: "#ff8484",
                    input: {
                      // fontSize: ".8rem",
                      direction: "rtl",
                    },
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  value={
                    detailRes && detailRes.cost
                      ? "- " + toMoney(detailRes.cost)
                      : 0
                  }
                  variant="filled"
                />
              ) : (
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={
                    detailRes && detailRes.giftCost !== 0
                      ? "مبلغ نهایی(درخواستی + هدیه)"
                      : "مبلغ درخواستی"
                  }
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    bgcolor: "#98e770",
                    input: {
                      // fontSize: ".8rem",
                      direction: "rtl",
                    },
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  value={
                    detailRes && detailRes.giftCost !== 0
                      ? toMoney(detailRes.totalCost) +
                        "(" +
                        toMoney(detailRes.cost) +
                        " + " +
                        toMoney(detailRes.giftCost) +
                        ")"
                      : "+ " + toMoney(detailRes.cost)
                  }
                  variant="filled"
                />
              )}
            </Box>

            <Box gridColumn="span 12">
              <TextField
                fullWidth
                id="outlined-basic"
                label="توضیحات"
                size="small"
                multiline
                rows={3}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  detailRes && detailRes.description
                    ? detailRes.description
                    : ""
                }
                variant="filled"
              />
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              gridColumn="span 12"
            >
              <Button
                // color="secondary"
                sx={{ mr: 2, width: "90px" }}
                variant="contained"
                onClick={() => setShowConfirm(true)}
              >
                تایید
              </Button>
              <Button
                sx={{ width: "90px" }}
                color="error"
                variant="contained"
                onClick={() => setShowNotConfirm(true)}
              >
                عدم تایید
              </Button>
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
